import type { JSX, ReactNode } from 'react';
import { eyebrow as eyebrowClass, pageTitle } from './look';

/** The top of every page but the overview: eyebrow, title, a line of context, an action. */
export function PageHead({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow: string;
  title: string;
  description?: string;
  action?: ReactNode;
}): JSX.Element {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-5">
      <div>
        <div className={eyebrowClass}>{eyebrow}</div>
        <h1 className={pageTitle}>{title}</h1>
        {description !== undefined && (
          <p className="text-mute mt-1.5 mb-0 text-sm">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
